// @flow
import React from 'react';
import { Button, Icon } from '@elements';

type Props = {
  onCheckSubscription: Function,
  onReopen: Function,
  isOpeningCheckout: boolean,
  disabled: boolean,
  isChecking: boolean,
  unconfirmed: boolean,
  _: Function,
};

// Shown once the browser checkout was opened, until the account is subscribed.
const WebCheckoutPending = ({
  onCheckSubscription, onReopen, isOpeningCheckout, disabled, isChecking, unconfirmed, _,
}: Props) => (
  <div className="webCheckoutPending">
    <Icon iconName="secure" size={28} className="icon" />
    <h2>{_('label/web_checkout_pending/title')}</h2>
    <p>{_('label/web_checkout_pending/text')}</p>
    {unconfirmed && !isChecking && (
      <p className="unconfirmed" role="status">{_('label/web_checkout_pending/unconfirmed')}</p>
    )}
    <div className="actions">
      <Button
        className="primary"
        text={_('action/web_checkout_done')}
        onClick={onCheckSubscription}
        isLoading={isChecking}
        loadingMessage={_('label/checking_subscription')}
      />
      <Button
        text={_('action/web_checkout_reopen')}
        onClick={onReopen}
        isLoading={isOpeningCheckout}
        disabled={disabled}
        loadingMessage={_('label/opening_checkout')}
        greenSpinner
      />
    </div>
  </div>
);

export default WebCheckoutPending;
